(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dynamic-section-replacement"] && !Shopify.designMode) return;
  try {
    
  // Function to process the table and add buttons
  function convertTableToDivs(table) {
    // Create a container div for the new structure
    const container = document.createElement('div');
    container.classList.add('div-table');

    // Process the table header (thead)
    const thead = table.querySelector('thead');
    if (thead) {
      const headerRow = document.createElement('div');
      headerRow.classList.add('div-table-header');

      Array.from(thead.rows[0].cells).forEach((cell) => {
        const headerCell = document.createElement('div');
        headerCell.classList.add('div-table-cell', 'header-cell');
        headerCell.textContent = cell.textContent;
        headerRow.appendChild(headerCell);
      });

      container.appendChild(headerRow);
    }

    // Process the table body (tbody)
    const tbody = table.querySelector('tbody');
    if (tbody) {
      Array.from(tbody.rows).forEach((row, rowIndex) => {
        const rowDiv = document.createElement('div');
        rowDiv.classList.add('div-table-row');

        Array.from(row.cells).forEach((cell, index) => {
          const cellDiv = document.createElement('div');
          cellDiv.classList.add('div-table-cell');

          // Add special styling or wrapper for the last column
          if (index === row.cells.length - 1 && rowIndex > 0) {
            cellDiv.classList.add('last-column');
            const value = cell.textContent.trim();
            // Check if the value is a product ID (numeric) or status text
            if (!isNaN(value)) {
              // If it's a product ID, add a "Buy Now" button
              cellDiv.innerHTML = `<button class="buy-now buy-now-custom" data-product-id="${value}">Buy Now</button>`;
            } else {
              // If it's status text, add a "discontinue" button
              cellDiv.innerHTML = `<button class="discontinue ${value.toLowerCase()}" data-status="${value}">${value}</button>`;
            }
          } else {
            cellDiv.textContent = cell.textContent;
          }

          rowDiv.appendChild(cellDiv);
        });

        container.appendChild(rowDiv);
      });
    }

    // Replace the original table with the new div-based structure
    table.parentNode.replaceChild(container, table);
  }

  // Find the table and convert it
  const table = document.querySelector('.replacement-table');
  if (table) {
    convertTableToDivs(table);
  }

  async function addToCart(productId, quantity = 1) {
    try {
      // Add the product to the cart using AJAX
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [
            {
              id: productId, // Variant ID of the product
              quantity: quantity,
            },
          ],
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to add product to cart.');
      }

      const cartData = await response.json();
      console.log('Product added to cart:', cartData);

      // Use the shared updateCartUI function
      if (typeof window.updateCartUI === 'function') {
        window.updateCartUI();
      }

      alert('Product added to cart successfully!');
    } catch (error) {
      console.error(error);
      alert('Error adding product to cart.');
    }
  }

  // Add event listeners for the buttons (optional)
  document.addEventListener('click', (event) => {
    if (event.target.classList.contains('buy-now-custom')) {
      const productId = event.target.getAttribute('data-product-id');
      addToCart(productId);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
const backToTopButton = document.querySelector('#back-to-top');

window.addEventListener('scroll', () => {
    if (window.pageYOffset > 400) {
        backToTopButton.style.display = 'flex';
    } else {
        backToTopButton.style.display = 'none';
    }
});

backToTopButton.addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      // this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-ticker"] && !Shopify.designMode) return;
  try {
    
  class Ticker {
    constructor(element) {
      this.track = element;
      this.content = element.querySelector('.ticker-content');
      this.speed = parseInt(element.closest('.ticker-section').dataset.speed) || 3;
      this.delay = parseInt(element.closest('.ticker-section').dataset.delay) || 2;
      this.init();
    }

    init() {
      console.info('INIT TICKER');
      // Clone items for seamless loop
      const clone = this.content.cloneNode(true);
      this.track.appendChild(clone);

      // Calculate animation duration based on content width
      const contentWidth = this.content.offsetWidth;
      const duration = (contentWidth / 100) * this.speed;
      // Set animation
      setTimeout(() => {
        this.content.style.animation = `ticker ${duration}s linear infinite`;
        clone.style.animation = `ticker ${duration}s linear infinite`;
      }, this.delay * 1000);

      // Pause on hover
      this.track.addEventListener('mouseenter', () => {
        this.content.style.animationPlayState = 'paused';
        clone.style.animationPlayState = 'paused';
      });

      this.track.addEventListener('mouseleave', () => {
        this.content.style.animationPlayState = 'running';
        clone.style.animationPlayState = 'running';
      });
    }
  }

  // Initialize tickers
  document.addEventListener('DOMContentLoaded', () => {
    const tickers = document.querySelectorAll('[data-ticker]');
    tickers.forEach((ticker) => new Ticker(ticker));
  });

  } catch(e) { console.error(e); }
})();
})();
